export var SESION_ACTIVAR = 'APP_SESION_ACTIVAR';
export var activarSesion = function activarSesion(id) {
  return {
    type: SESION_ACTIVAR,
    id: id
  };
};
export var SESION_CREAR = 'APP_SESION_CREAR';
export var crearSesion = function crearSesion(nombre) {
  return {
    type: SESION_CREAR,
    nombre: nombre
  };
};
export var SESION_ELIMINAR = 'APP_SESION_ELIMINAR';
export var eliminarSesion = function eliminarSesion(id) {
  return {
    type: SESION_ELIMINAR,
    id: id
  };
};
export var SESIONES_INICIALIZAR = 'APP_SESIONES_INICIALIZAR';
export var inicializarSesiones = function inicializarSesiones(sesiones, idUltimaSesionActiva) {
  return {
    type: SESIONES_INICIALIZAR,
    sesiones: sesiones,
    idUltimaSesionActiva: idUltimaSesionActiva
  };
};
export var SESION_IMPORTAR = 'APP_SESION_IMPORTAR';
export var importarSesion = function importarSesion(sesion) {
  return {
    type: SESION_IMPORTAR,
    sesion: sesion
  };
};
export var SESION_EXPORTAR = 'APP_SESION_EXPORTAR';
export var exportarSesion = function exportarSesion(sesion) {
  return {
    type: SESION_EXPORTAR,
    sesion: sesion
  };
};